// extracted by mini-css-extract-plugin
module.exports = {"root":"button_root__3ZVpF","root_normalPriority":"button_root_normalPriority__1gAsS button_root__3ZVpF","root_whitePriority":"button_root_whitePriority__218Ng button_root__3ZVpF"};